import { CostBasisCell, CostBasisLegend, CostBasisSummary } from '@wavvest/wealth-ui';
import '@wavvest/wealth-ui/cost-basis.scss';
import { useAccountBasis, useBasisEnabled } from './context';
import { useLotsSource } from './lots';

type Holding = { asset_id?: string | null; symbol?: string | null; cost_basis_metadata?: unknown };

export function BasisCell({
  accountId,
  holding,
  gain = false,
  external = false,
}: {
  accountId: string;
  holding: Holding;
  gain?: boolean;
  external?: boolean;
}) {
  const basis = useAccountBasis(external ? undefined : accountId);
  const lots = useLotsSource(basis.state?.apexId);
  // Client Portal holdings carry the Apex asset ID directly.
  return (
    <CostBasisCell
      basis={basis}
      holding={holding}
      assetId={holding.asset_id}
      lots={lots}
      gain={gain}
      external={external}
    />
  );
}

export function AccountBasisSummary({ accountId, name }: { accountId: string; name: string }) {
  const basis = useAccountBasis(accountId);
  const lots = useLotsSource(basis.state?.apexId);
  return <CostBasisSummary basis={basis} name={name} lots={lots} />;
}

export function BasisLegend() {
  return <CostBasisLegend enabled={useBasisEnabled()} />;
}
